export default "__VITE_ASSET__DR$un9lI__"